import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileType } from "@bpm/models/file-type";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'root'})
export class FileTypeService {

    constructor(private _http: HttpClient){}

    getAll(){
        return this._http.get<FileType[]>
        (`${environment.bpmApiUrl}/api/file-type`);
    }

    getByMenuId(menu:number){
        return this._http.get<FileType[]>
        (`${environment.bpmApiUrl}/api/file-type/menu/${menu}`);
    }
}
